import styled from 'styled-components'

const Page = styled.div`
  z-index: 9999;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -50px;
  text-align: center;
`

const Title = styled.h1`
  text-align: center;
`

const SubjectDoesNotExist = () => {
  return (
    <Page>
      <Title>This reference is now complete</Title>
      <div>
        <span>
          We no longer need you to provide information for this application. You may now
          close this window.
        </span>
      </div>
    </Page>
  )
}

export default SubjectDoesNotExist
